import { buildAnalyticsHead } from '../utils/analytics';

// Universal (not .client) so the tags are in the SSR HTML and the GTM <noscript> fallback works.
export default defineNuxtPlugin(() => {
  const { gtmId } = useRuntimeConfig().public;
  const head = buildAnalyticsHead({ gtmId });

  if (head) {
    useHead(head);
  }
});
